import { Component, OnInit, ViewChild, ViewChildren, Inject } from '@angular/core';
import {TemplateService} from '../template.service'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { Iconlibrarydialog } from '../../bots/bots.component';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertService } from 'src/app/alert/alert.service';
import { NgbDropdownConfig, NgbDropdown, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-template',
  templateUrl: './add-template.component.html',
  styleUrls: ['./add-template.component.css'],
  providers: [ { provide: MAT_DIALOG_DATA, useValue: {} } ]
})
export class AddTemplateComponent implements OnInit {
dropdown_icon=false;
dropdown_text = "Add buttons";
name:any="";
char_len = 0;
textContent:any="";
replacedContent:any="";
documentName:any="{2}";
urlName:any="";
textMessage:any="";
SelectedValue:any = null;
SelectedOption:any = 1;
selectedFile: any = null;
error_message = [];
textWithButton:any="text"
selected:any = [];
buttons =[];
reply:any;
@ViewChild('sidenav') sidenav;
section = 1;
variableData = new Array(6);
valData = [];
_data:any;
uploadImage: string | ArrayBuffer;
addTemplate: FormGroup;
avail: boolean = null;
validated:any='';
options = {
  autoClose: false,
  keepAfterRouteChange: false
};
loading = false;
toaster = false;
@ViewChild('successDialogue') successDialogue;
@ViewChild('errordialog') errordialog;
@ViewChild('myngbDropDown') dropdown_1:NgbDropdown;
  constructor(private service:TemplateService, private toastr: ToastrService, public _matDialog: MatDialog, 
    private router: Router, public alertService: AlertService,config: NgbDropdownConfig, 
    @Inject(MAT_DIALOG_DATA) public data: {name: string}) { }

  ngOnInit(): void {
    this.addTemplate = new FormGroup({
      templateName: new FormControl('',[Validators.pattern('^[a-z0-9_]+$')])
    });
    this.variableData.fill('text');
  }

  get f() {return this.addTemplate.controls; }

  addVar() {
    let check = 4; 
    if(this.SelectedValue !== 'text' && this.SelectedValue !== 'document') {
      this.variableData[0] = '';
      check = 5;
    } else if(this.SelectedValue === 'document') {
      this.variableData[0] = '';
      this.variableData[1] = this.variableData[1] === null ? null : '';
      check = 6;
    }
    const len = this.variableData.filter(x => x !== 'text');
    const ind = this.variableData.findIndex(x=>x === 'text');
    if( len.length < check && ind > -1) {
      this.variableData[ind] = null;
      var elem = document.getElementById('textarea_content');
      var textarea : HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById("textarea_content");
      let curPos = textarea.selectionStart;
      if(curPos>=0){
        this.textContent = this.textContent.slice(0, curPos) + `{${ind+1}}` + this.textContent.slice(curPos);
      }
      else {
        this.textContent = this.textContent+`{${ind+1}}`;
      }
      // const input : HTMLInputElement = <HTMLInputElement>elem;
      // input.innerHTML = input.innerHTML+`{${ind+1}}`;

      // input.innerHTML = this.textformatting(input.innerHTML,this.getCaretPosition(elem),`{${ind+1}}`);
      
      // this.textContent = input.innerHTML;
      this.setEndOfContenteditable(elem)
    }
  }

  addDocVar() {
    if(this.documentName.indexOf('{2}') === -1) {
      const ind = this.variableData.findIndex(x=>x === 'text');
      this.variableData[1] = null;
      this.documentName = this.documentName + '{2}';
    }
  }

  setEndOfContenteditable(contentEditableElement)
  {
      const end = contentEditableElement.value.length;
      contentEditableElement.setSelectionRange(end, end);
      contentEditableElement.focus();
      // document.execCommand('selectAll', false, null);
      // document.getSelection().collapseToEnd();
  }

  createButtons(value){

    this.selected.length = value
    this.buttons = []
    let baseObject = {body: '',reply:'',icon:'' }
    for(let i=0;i<value;i++){
      this.buttons[i] = {...baseObject}
    }
  }

  myFunction(event){
    this.dropdown_icon = event
  }
  
  textformatting(origString,indexPosition,stringToAdd){
    origString = origString.split('');
    origString.splice(indexPosition, 0, stringToAdd);
    let newString = origString.join('');
    return newString
  }

  getCaretPosition(editableDiv) {
    var caretPos = 0, sel, range;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel.rangeCount) {
        range = sel.getRangeAt(0);
        if (range.commonAncestorContainer.parentNode == editableDiv) {
          caretPos = range.endOffset;
        }
      }
    } else if (editableDiv.selection && editableDiv.selection.createRange) {
      range = editableDiv.selection.createRange();
      if (range.parentElement() == editableDiv) {
        var tempEl = document.createElement("span");
        editableDiv.insertBefore(tempEl, editableDiv.firstChild);
        var tempRange = range.duplicate();
        tempRange.moveToElementText(tempEl);
        tempRange.setEndPoint("EndToEnd", range);
        caretPos = tempRange.text.length;
      }
    }
    return caretPos;
  }

  resetselectedVal() {
    this.variableData.fill('text');
    this.textContent = '';
    this.replacedContent = '';
    this.valData = [];
    this.buttons = [];
    this.selected = [];
    this.SelectedOption = 1;
    this.urlName = '';
    this.textWithButton = 'text';
    this.uploadImage = null;
    this.toaster = false;
  }

  checkData() {
    return this.variableData.filter(x => x != 'text' && x!='');
  }

  goNextTab(tab) {
      this.section = tab;
      this.resetselectedVal();
      $('.active-group > .active').next().addClass("active").siblings().removeClass("active");
      if(tab === 3) {
        setTimeout(() => {
          this.setEndOfContenteditable(document.getElementById('textarea_content'));
        }, 300);
      }
  }
  onInput(target){
    this.textContent = target.value;
    // var regex = /(<([^>]+)>)/ig;
    // var result = this.textContent.replace(regex, "");
    // this.char_len = result.length;
    this.char_len = this.textContent.length;
      if(this.variableData) {
        this.variableData.map((x, i) => {
          if(target.value.indexOf(`{${i+1}}`) == -1) {
            this.variableData[i] = 'text';
          } else {
            this.variableData[i] = null;
          }
        });
      }
  }

  valuechange(event, i) {
    if(event.target.value !== '') {
      this.valData[i] = event.target.value;
    }
  }

  toggleclass(id) {
    document.getElementById(id).classList.toggle('active');
  }

  addFormatting(event, val) {
    var regex = /(<([^>]+)>)/ig;
    var elem = document.getElementById('textarea_content');
    if(val =="bold" ||val =="italic" ){
      document.execCommand(val);
      var result = this.textContent.replace(regex, "");
      this.char_len = result.length;
      // this.setEndOfContenteditable(elem)
    }
  }

  commonFormatting(character){
    const textarea = document.getElementById('textarea_content');
    const input : HTMLInputElement = <HTMLInputElement>textarea;
    var startPos = input.selectionStart;
    var endPos = input.selectionEnd;
    if(startPos >0){
      this.textContent = input.value.substring(0, startPos) + character + input.value.substring(startPos, endPos) +  character + input.value.substring(endPos, input.value.length);
    }
    else{
      this.textContent = this.textContent +character+character;
    }
    setTimeout(() => {
      this.focus(textarea, this.textContent.length);
    });

  }
  addBold(event, val) {
    this.commonFormatting("*")
  }
  addItalic(event, val) {
    this.commonFormatting("_")
  }
  addStrike(event, val) {
    this.commonFormatting("~")
  }
  addUnderline(event, val) {
    this.textContent = this.textContent + '**';
    const textarea = document.getElementById('textarea_content');
    setTimeout(() => {
      this.focus(textarea, this.textContent.length);
    });
  }
  // addBold(event, val) {
  //   this.textContent = this.textContent + '**';
  //   const textarea = document.getElementById('textarea_content');
  //   setTimeout(() => {
  //     this.focus(textarea, this.textContent.length);
  //   });
  // }

  focus(textarea, end) {
    textarea.setSelectionRange(end, end-1);
    textarea.focus();
  }

  clearall(){
    var elem = document.getElementById('textarea_content');
    // const input : HTMLInputElement = <HTMLInputElement>elem;
    // input.innerHTML = '';
    this.textContent = '';
    this.char_len = 0;
    this.variableData.fill('text');
  }
  
  checkTemplateName(event) {
    let pattern = /^[a-z0-9_]+$/;
    if(event.target.value && pattern.test(event.target.value)) {
      this.loading = true;
      const merchant_id = JSON.parse(localStorage.getItem('merchantDetails')).merchant_id;
      this.service.getTemplateByName(merchant_id, event.target.value).subscribe(x => {
        if(x == null) {
          this.avail = true;
        } else {
          this.avail = false;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        console.log(error);
      });
    }
  }

  validation(){
    this.error_message= []
    if(this.name&&this.textContent){
      this.validated="done";

      if(this.SelectedValue == 'document'&&this.documentName){
        this.validated="done";
      }
      else if(this.SelectedValue == 'button'&&this.buttons.length>0){
        for(let i=0;i<this.buttons.length;i++){
          if(!this.buttons[i].body || !this.buttons[i].reply){
            this.validated="error";
            if(!this.buttons[i].body){this.error_message.push("Button " + (i+1) +' Body');}
            if(!this.buttons[i].reply){this.error_message.push("Button " + (i+1) +' Reply');}
          }
          else{
            this.validated="done";
          }
        }

      }
      else{
        this.error_message.push("Add buttons")
        this.validated="error";
        
      }
    }
    else{
      this.validated="error";
      
    }
  }

  saveTemplate(event) {
    this.validation();
      this.valData.map((x, index) => {
        if(x) {
          this.replacedContent = this.textContent.replace(`{${index+1}}`, this.valData[index]);
        }
      });
      if(this.SelectedValue == 'text'){
        if(this.textContent === null || this.textContent === '') {
          this.error_dialog('Please fill all mandatory fields');
          this.error_message.push('text content');
          this.toaster = true;
          return;
        }
        this._data = {
         "name": this.name,
         "template":{
           "type":this.SelectedValue,
           "text":{
             "body": this.textContent
           }
         }
       }
     }else if (this.SelectedValue == 'document'){
      if(this.SelectedOption == null || this.textContent === null || this.textContent === ''
       ||this.documentName === null || this.documentName === '' || this.documentName.indexOf('{2}') === -1) {
        this.error_dialog('Please fill all mandatory fields');
        if(this.textContent === null || this.textContent === ''){this.error_message.push('Text Content');}
        if(this.documentName === null || this.documentName === '' || this.documentName.indexOf('{2}') === -1){this.error_message.push('Document Name');}
        this.toaster = true;
        return;
      }
       this._data = {
         "name": this.name,
         "template":{
           "type":this.SelectedValue,
           "document":{
             "name": this.documentName,
             "body": this.textContent
           }
         }
       }
       delete this._data.template.document.id;
       delete this._data.template.document.url;
       if(this.SelectedOption == 1) this._data.template.document.id = '{1}';
       else if(this.SelectedOption == 2) this._data.template.document.url = '{1}';
     }else if (this.SelectedValue == 'image'){
      if(this.SelectedOption == null || this.textContent === null || this.textContent === '') {
        this.error_dialog('Please fill all mandatory fields');
        this.error_message.push('Text Content');
        this.toaster = true;
        return;
      }
       this._data = {
         "name": this.name,
         "template":{
           "type":this.SelectedValue,
           "image":{
             "body": this.textContent
           }
         }
       }
       delete this._data.template.image.id;
       delete this._data.template.image.url;
       if(this.SelectedOption == 1) this._data.template.image.id = '{1}';
       else if(this.SelectedOption == 2) this._data.template.image.url = '{1}';
     }
     else if (this.SelectedValue == 'video'){
      if(this.SelectedOption == null || this.textContent === null || this.textContent === '') {
        this.error_dialog('Please fill all mandatory fields');
        this.error_message.push('Text Content');
        this.toaster = true;
        return;
      }
       this._data = {
         "name": this.name,
         "template":{
           "type":this.SelectedValue,
           "video":{
             "title": this.textContent
           }
         }
       }
       delete this._data.template.video.id;
       delete this._data.template.video.url;
       if(this.SelectedOption == 1) this._data.template.video.id = '{1}';
       else if(this.SelectedOption == 2) this._data.template.video.url = '{1}';
     } else if (this.SelectedValue == 'button') {
      if ((this.SelectedOption == null && this.textWithButton == "image")|| this.textContent === null || this.textContent === '') {
        this.error_dialog('Please fill all mandatory fields');
        this.error_message.push('Text Content');
        this.toaster = true;
        return;
      }
      this.buttons.map(x=>x.icon === '' && delete x.icon);
      this._data = {
        "name": this.name,
        "template": {
          "type": this.SelectedValue,
          "button": {
            "body": {
              "type": this.textWithButton,
              [this.textWithButton]: {
                "body": this.textContent
              }
            },
            "buttons": this.buttons
          }
        }
      }
     
     if(this.SelectedOption == 1 && this.textWithButton != 'text') this._data.template.button.body[this.textWithButton].id = '{1}';
     else if(this.SelectedOption == 2 && this.textWithButton != 'text') this._data.template.button.body[this.textWithButton].url = '{1}';
   }
   this.toaster = false;
     this.service.createTemplate(this._data).subscribe(
               result => {
                 if(result === 'Created'){
                  this.router.navigate(['/templates']);
                  this._matDialog.open(this.successDialogue, {
                    panelClass: 'custom-mat-dialog-container',
                    backdropClass: 'backdropnone',
                    position: {
                      'top' : '5%',
                      'left' : '45%'
                    }
                  });
                 }else{
                  this.error_dialog("Something went wrong, please try later.");
                 }
               },
               error => {
                this.error_dialog(JSON.parse(error.error).message);
              }
     );
  }

  error_dialog(data){
    this.data.name = data;
    this._matDialog.open(this.errordialog, {
      panelClass: 'custom-mat-dialog-container',
      backdropClass: 'backdropnone',
      position: {
        'top' : '4%',
        'left' : '34%'
      }
    });
  }
  
  bold(text){
    var bold = /\*(.*?)\*/gm;
    var italic = /\_(.*?)\_/gm;
    var Strike = /\~(.*?)\~/gm;
    var html = text.replace(bold, '<strong>$1</strong>');    
    html = html.replace(italic, '<i>$1</i>');            
    html = html.replace(Strike, '<s>$1</s>');            
    return html;
  }

  replacedText(){
    if(this.valData.length > 0){
      this.replacedContent = this.textContent.slice(0);      
      if(this.valData[0]) this.replacedContent = this.replacedContent.replace(`{1}`, this.valData[0]);
      if(this.valData[1]) this.replacedContent = this.replacedContent.replace(`{2}`, this.valData[1]);
      if(this.valData[2]) this.replacedContent = this.replacedContent.replace(`{3}`, this.valData[2]);
      if(this.valData[3]) this.replacedContent = this.replacedContent.replace(`{4}`, this.valData[3]);
      if(this.valData[4]) this.replacedContent = this.replacedContent.replace(`{5}`, this.valData[4]);
      if(this.valData[5]) this.replacedContent = this.replacedContent.replace(`{6}`, this.valData[5]);
      this.replacedContent = this.bold(this.replacedContent);
      return this.replacedContent;
    } else {
      this.replacedContent = this.bold(this.textContent);
      return this.replacedContent;
    }
  }
  onURLEntered(){
    this.uploadImage = this.urlName;
    setTimeout(() =>{
      const a = document.getElementById('preview_image')
      if(a) document.getElementById('preview_image').setAttribute('src', this.urlName);
    }, 300);
  }
  onFileSelected(event: any): void {
    const maxFileSize = 10 * 1024 * 1024;
    this.selectedFile = event.target.files[0] ?? null;
    if (this.file_validation(this.selectedFile.type)) {
      if(this.selectedFile.size <= maxFileSize) {
        this.alertService.clear();
        const reader = new FileReader();
        reader.onload = e => this.uploadImage = reader.result;
        reader.readAsDataURL(this.selectedFile);
        setTimeout(() =>{
          const a = document.getElementById('preview_image')
          if(a) document.getElementById('preview_image').setAttribute('src', this.uploadImage.toString());
        }, 300);
      } else {
        this.alertService.error('Please upload file less than 10mb.', this.options);
      }
    }
  }

  file_validation(type) {
    if ((this.SelectedValue == 'image')||(this.SelectedValue == 'button' && this.textWithButton == 'image')) {
      let supportedFormats = ['image/jpg', 'image/jpeg', 'image/png'];
      if (0 > supportedFormats.indexOf(type)) {
        this.alertService.error('Unsupported file format', this.options);
        return false
      }
      else {
        return true
      }
    } else if(this.SelectedValue == 'video') {
      let supportedFormats = ['video/mp4'];
      if (0 > supportedFormats.indexOf(type)) {
        this.alertService.error('Unsupported file format', this.options);
        return false
      }
      else {
        return true
      }
    } else {
      let supportedFormats = ['application/pdf'];
      if (0 > supportedFormats.indexOf(type)) {
        this.alertService.error('Unsupported file format', this.options);
        return false
      }
      else {
        return true
      }
    }
  }
  
  openIconPopup(index) {
    const iconLibraryDialogRef = this._matDialog.open(Iconlibrarydialog);
    iconLibraryDialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.buttons[index].icon = result.data
      }
    });
  }

  deleteIcon(index) {
    this.buttons[index].icon =''
  }

  openCheckDemo(){
    this._matDialog.open(CheckDemoDialog)
  }
}

@Component({
  selector: 'checkDemo-dialog',
  templateUrl: 'checkDemo-dialog.html',
  styleUrls: ['checkDemo-dialog.css'],
})
export class CheckDemoDialog {
  templateType:string ='';
  imageTemp:boolean = false;
  videoTemp:boolean = false;
  docuTemp:boolean = false;
  textTemp:boolean = false;
  imageButtonTemp:boolean = false;
  textButtonTemp:boolean = false;
  constructor(
    public IcondialogRef: MatDialogRef<Iconlibrarydialog>,
    
  ) {  }

  closePopup() {
    this.IcondialogRef.close({ event: 'close', data: undefined });
  }
   openImage(){
    this.imageTemp = true;
    this.templateType = 'Image';
    this.videoTemp = false;
    this.docuTemp = false;
    this.textTemp = false;
    this.imageButtonTemp = false;
    this.textButtonTemp = false;
   }
   openVideo(){
    this.videoTemp = true;
    this.templateType = 'Video';
    this.imageTemp = false;
    this.docuTemp = false;
    this.textTemp = false;
    this.imageButtonTemp = false;
    this.textButtonTemp = false;
   }
   openDocument(){
    this.docuTemp = true;
    this.templateType = 'Document';
    this.videoTemp = false;
    this.imageTemp = false;
    this.textTemp = false;
    this.imageButtonTemp = false;
    this.textButtonTemp = false;
   }
   openText(){
    this.textTemp = true;
    this.templateType = 'Text';
    this.docuTemp = false;
    this.videoTemp = false;
    this.imageTemp = false;
    this.imageButtonTemp = false;
    this.textButtonTemp = false;
   }
   openImagewithBUtton(){
    this.imageButtonTemp = true;
    this.templateType = 'Image with button';
    this.docuTemp = false;
    this.videoTemp = false;
    this.textTemp = false;
    this.textButtonTemp = false;
    this.imageTemp = false;
   }
   openTextwithBUtton(){
    this.textButtonTemp = true;
    this.templateType = 'Text with button';
    this.docuTemp = false;
    this.videoTemp = false;
    this.imageButtonTemp = false;
    this.textTemp = false;
    this.imageTemp = false;
   }
}